'use strict';

import versioner from '../versioner';
import process from './process';

versioner['servpro_of_boulder_beta'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.servpro_of_boulder';

export default MODULE_NAME;
